import { ReactNode } from "react";
import { cn } from "../../lib/utils";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle
} from "../ui/common/sheet";

export interface TailwindSideModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  title?: string;
  description?: ReactNode;
  testId?: string;
  contentClassName?: string;
  headerClassName?: string;
}

const TailwindSideModal = ({
  open,
  onOpenChange,
  children,
  title,
  description,
  testId,
  contentClassName,
  headerClassName
}: TailwindSideModalProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        data-testid={testId}
        className={cn(
          "!tw-w-full sm:!tw-max-w-5xl !tw-p-0 tw-flex tw-flex-col",
          contentClassName
        )}
      >
        <SheetHeader
          className={cn(
            "tw-shrink-0 tw-border-b tw-border-border tw-px-6 tw-pt-6 tw-pb-2",
            headerClassName
          )}
        >
          <SheetTitle className="tw-text-lg tw-font-bold tw-text-foreground">{title}</SheetTitle>
          {description ? <SheetDescription>{description}</SheetDescription> : null}
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
};

export default TailwindSideModal;
